import { createRouter, createWebHistory } from 'vue-router'

import Game from '../views/Game'
import Gateway from "@/views/Gateway.vue";


const routes = [
  {
    path: '/',
    name: 'game',
    component: Game
  },
  {
    path: "/gateway",
    name: "gateway",
    component: Gateway
  },
]

const router = createRouter({
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  },
  history: createWebHistory('/'),
  routes
})

export default router
